class CookieHelper {
    /**
     * retrieves value stored in specific cookie as a string
     * @param name
     * @returns {string|null}
     */
    static getCookieValue(name) {
        const regex = new RegExp(`${name}=([^;]+)`);
        const value = regex.exec(document.cookie);

        return (value != null) ? value[1] : null;
    }

    /**
     * set cookie
     * @param name
     * @param value
     * @param expirationDays
     */
    static setCookie(name, value, expirationDays = 31) {
        const date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));

        document.cookie = `${name}=${value}; expires="${date.toUTCString()}; path=/`;
    }

    /**
     * listen for change in cookieconsent and trigger
     * custom event if marketing cookies have been accepted
     */
    static addMarketingCookieListener(customEvents = []) {
        document.addEventListener('sfcookieconsent_marketing', () => {
            for (const event of customEvents) {
                const customEvent = new CustomEvent(event);
                window.dispatchEvent(customEvent);
            }
        }, false);
    }
}

export default CookieHelper;
